import { render, staticRenderFns } from "./CheckupList.vue?vue&type=template&id=56a44250&scoped=true"
import script from "./CheckupList.vue?vue&type=script&lang=js"
export * from "./CheckupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a44250",
  null
  
)

export default component.exports